// extracted by mini-css-extract-plugin
export default {"edit":"edit__yNeu6","JSONEdit_border":"JSONEdit_border__NkbNG"};